import styled from 'styled-components';

const HeaderMobile = styled.div`
	display: flex;
	align-items: center;
	color: #ffeb00;
	display: flex;
	align-items: center;
	background: ${({ theme }) => theme.backgroundHeaderMobile};

	.header-bar {
		display: flex;
		flex-direction: column;
		padding: 10px;
		text-align: center;
		box-shadow: 0px 4px 9px -5px grey;
		span {
			margin-left: 8px;
			font-weight: bolder;
			font-size: 12px;
		}
	}
	.logomobile {
		margin-bottom: 0;
	}
	h4 {
		position: relative;
		top: 12px;
		font-size: 20px;
		margin: 0px 75px 0 0;
		font-weight: 900;
	}

	.logoConsulta {
		margin: 0 auto !important;
	}

	.headerLogo {
		filter: ${({ theme }) => theme.filterLogoHeader};
	}

	@media screen and (min-width: 600px) {
		.header h4 {
			margin: 0 180px 0 0;
		}

		.yalo-title {
			h4 {
				font-size: 32px !important;
			}
		}
	}
`;

export default HeaderMobile;
